module.exports = __webpack_public_path__ + "media/images/lb/038-632c63c137c5ae8af48e2d64fa2f3114.svg";